<template>
    <ion-card>
        <ion-card-header>
            <ion-card-title v-show="title && title.length > 0">{{ title }}</ion-card-title>
            <ion-card-subtitle v-show="subtitle && subtitle.length > 0">{{ subtitle }}</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
            <slot></slot>
        </ion-card-content>
    </ion-card>
</template>


<script>

import {IonCard, IonCardContent, IonCardTitle, IonCardHeader, IonCardSubtitle} from '@ionic/vue';

export default {
    name: "NoResults",
    props: {title: String, subtitle: String},
    components: {IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCardSubtitle}
}
</script>

<style scoped>

</style>
